export const TIMEZONES = [
  { value: "America/New_York", label: "(UTC-5) Eastern Time" },
  { value: "America/Chicago", label: "(UTC-6) Central Time" },
  { value: "America/Denver", label: "(UTC-7) Mountain Time" },
  { value: "America/Los_Angeles", label: "(UTC-8) Pacific Time" },
  { value: "America/Juneau", label: "(UTC-9) Alaska Time" },
  { value: "Pacific/Honolulu", label: "(UTC-10) Hawaii Time" },
  { value: "America/Phoenix", label: "(UTC-7) Arizona Time" },
  { value: "America/Puerto_Rico", label: "(UTC-4) Atlantic Time" }
]
